import PatientInfoHeader from './PatientInfoHeader'

export default PatientInfoHeader



// WEBPACK FOOTER //
// ./src/legacy/containers/PatientInfoHeader/index.js